import angular from 'angular';
import $ from 'jquery';
import {favicons} from "../constants/favicons";

export function DocumentService($location) {
    const getProcessedHtml = (htmlElement, options = { webApp: false }) => {
        if (!options.webApp) {
            const hostLocation = getCurrentLocation();
            const filteredHtml = removeHidden(htmlElement);
            const processedHtml = processAssets(filteredHtml, hostLocation);
            const head = getHeadContent();
            const body = getBodyContent(processedHtml, hostLocation, options);

            return `
            <html>
                ${head}
                ${options.script ? options.script : ''}
                ${body}
            </html>
        `;
        } else {
            return htmlElement;
        }
    };

    const getCurrentLocation = () => `${$location.$$protocol}://${$location.$$host}:${$location.$$port}`;

    const getHeadContent = () => `<head>${document.head.innerHTML}</head>`;

    const getBodyContent = (htmlElement, hostLocation) => `
        <body class="print">
            <div class="watermark-placeholder">
                <img class="print-orange-strip" src="${hostLocation}/assets/img/orange-strip.png"/>
                    ${htmlElement.innerHTML}
            </div>
        </body>
    `;

    const processAssets = (htmlElement, hostLocation) => {
        const htmlElementCopy = $(htmlElement).clone();

        [...$(htmlElementCopy).find('*')].forEach((el) => {
            const src = $(el).attr('src');

            if (src && (src.startsWith('assets/') || src.startsWith('/assets/'))) {
                $(el).attr('src', `${hostLocation}/${src}`);

                return;
            }

            const href = $(el).attr('xlink:href');

            if (href && (href.startsWith('assets/') || href.startsWith('/assets/'))) {
                $(el).attr('xlink:href', `${hostLocation}/${href}`);
            }
        });

        return htmlElementCopy[0];
    };

    const removeHidden = (htmlElement) => {
        const htmlElementCopy = $(htmlElement).clone();

        [...$(htmlElementCopy).find('.hideInPrint')].forEach(element => element.remove());
        [...$(htmlElementCopy).find('.ng-hide')].forEach(element => element.remove());

        return htmlElementCopy[0];
    };

    const changeFavicon = (isPaycorEmployerRedAdmin) => {
        const link = $("link[rel~='icon']");
        if (link) {
            const favicon = isPaycorEmployerRedAdmin ? favicons.PAYCOR : favicons.TALENYA;
            link.attr('href', favicon);
        }
    };

    return {
        getCurrentLocation,
        getProcessedHtml,
        getHeadContent,
        changeFavicon,
    };
}

angular.module('TALENYA-FE').factory('DocumentService', DocumentService);
